<template>
  <div v-if="announcement.show" class="container">
    <span class="heading">
      <v-icon color="#555" class="icon">announcement</v-icon>
    </span>
    <ul>
      <li v-for="item in announcement.items" :key="item.id" :class="listStyle(item.color)">
        <div class="listItem__datetime">{{ item.datetime }}</div>
        <div class="listItem__text" v-html="item.text"></div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Announcement',
  props: {
    announcement: { type: Object, required: false }
  },
  methods: {
    listStyle: function(color) {
      if (color === 'black') return 'text-bold';
      if (color === 'red') return 'color-red text-bold';
      return '';
    }
  }
};
</script>

<style scoped>
ul {
  padding: 0;
}
.text-bold {
  font-weight: 700;
}
.color-red {
  color: red;
  font-weight: 700;
}
.heading {
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(50%, -50%);
  width: 2.5rem;
  height: 2.5rem;
  background-color: #fff;
  border-radius: 50%;
}
.icon {
  line-height: 2.5rem;
}
.container {
  position: relative;
  background-color: #fff;
  width: 60rem;
  min-height: 6.25rem;
  max-height: 14rem;
  border-radius: 5px;
}
li {
  list-style: none;
  display: flex;
  text-align: left;
  align-items: center;
}
li:not(:last-child) {
  margin-bottom: 0.5rem;
}
.listItem__datetime {
  width: 10rem;
  white-space: nowrap;
  justify-content: flex-start;
  margin-right: 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/_organisms/Announcement.vue